export default "__VITE_ASSET__DzUITz61__"